import {
  CheckIcon,
  SkipIcon,
  DotFillIcon,
  SquareFillIcon,
  QuestionBubbleIcon,
  ClockIcon,
  CircleSlashIcon,
} from '@primer/octicons-react'
import {WorkingAsciiLoader} from '@github-ui/agent-sessions-interface/components/WorkingAsciiLoader'
import {isCopilotCodingAgent} from '@github-ui/copilot-shared-ui/agents/agent-helpers'
import {SessionState, type Session} from '../types/session'
import styles from './StatusIcon.module.css'

export function SessionLoadingIcon({ariaLabel}: {ariaLabel?: string}) {
  return <WorkingAsciiLoader ariaLabel={ariaLabel} className={styles.loadingStatus} />
}

export function getSessionStatusIcon(status: SessionState, agentSlug?: Session['agent_slug']) {
  switch (status) {
    case SessionState.InProgress:
      return <SessionLoadingIcon ariaLabel="Currently running" />
    case SessionState.Completed:
      return <CheckIcon className="fgColor-success" aria-label="Completed" />
    case SessionState.Failed:
    case SessionState.TimedOut:
      return <SkipIcon className="fgColor-danger" aria-label="Failed" />
    case SessionState.Idle:
      return <DotFillIcon className="fgColor-attention" aria-label="Idle" />
    case SessionState.WaitingForUser:
      return <QuestionBubbleIcon className="fgColor-attention" aria-label="Waiting for user" />
    case SessionState.Cancelled:
      return isCopilotCodingAgent(agentSlug) ? (
        <CircleSlashIcon className="fgColor-muted" aria-label="Cancelled" />
      ) : (
        <SquareFillIcon className="fgColor-muted" aria-label="Cancelled" />
      )
    case SessionState.Queued:
      return <ClockIcon className="fgColor-attention" aria-label="Queued" />
    default:
      return null
  }
}

export function InProgressSpinner() {
  return (
    <svg
      role="img"
      aria-label="Currently running"
      width="16px"
      height="16px"
      fill="none"
      viewBox="0 0 16 16"
      className="anim-rotate"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="none"
        stroke="var(--fgColor-attention)"
        strokeWidth="2"
        d="M3.05 3.05a7 7 0 1 1 9.9 9.9 7 7 0 0 1-9.9-9.9Z"
        opacity=".5"
      />
      <path
        fill="var(--fgColor-attention)"
        fillRule="evenodd"
        d="M8 4a4 4 0 1 0 0 8 4 4 0 0 0 0-8Z"
        clipRule="evenodd"
      />
      <path fill="var(--fgColor-attention)" d="M14 8a6 6 0 0 0-6-6V0a8 8 0 0 1 8 8h-2Z" />
    </svg>
  )
}
